var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualReportsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9427 3.33333H10V0.390667L12.9427 3.33333ZM13.3333 4.66667V16H0V2C0 0.895333 0.895333 0 2 0H8.66667V4.66667H13.3333ZM4.66667 10.6667H3.33333V13.3333H4.66667V10.6667ZM7.33333 7.33333H6V13.3333H7.33333V7.33333ZM10 9.33333H8.66667V13.3333H10V9.33333Z",
    fill: "#132A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualReportsIcon);
export default __webpack_public_path__ + "static/media/VisualReportsIcon.b1fd5f884bc617fc7a7019dead6e3ea1.svg";
export { ForwardRef as ReactComponent };